var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVarlk2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.88 43.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e3ddd8",
    d: "M77.27,28.11l-.04-.08c-.46-1.13-1.12-2.14-1.97-3.01l-.29-.29-.05-.05,5.72-15.75,6.96,19.17h-10.34ZM56.07,20.98V1.5h4.45c5.94,0,9.08,3.53,9.08,10.21,0,7.1-1.81,9.27-7.71,9.27h-5.82ZM27.01,28.15l6.96-19.18,6.96,19.18h-13.92ZM99.89,42.45L83.82.08l-.03-.08h-.24l-8.88,24.47c-2.01-1.78-4.85-2.89-8.43-3.3l-1.09-.12,1.08-.13c5.9-1.06,9.87-4.79,9.87-9.28,0-6.16-5.79-10.46-14.09-10.46h-17.48v.31h5.02v31.28L37.12.03h-.24l-15.36,42.36h-.08c-.53.07-1.04.1-1.55.1H7.51L31.74,1.19H2.35v12.67h.31c.05-6.17,3.65-12.36,11.59-12.36h10.05L0,42.8h32.1v-12.14h-.31c-.04,5.38-3.09,10.49-9.72,11.64l-.21.04,5.05-13.88h14.17l5.04,14h-4.95v.31h19.95v-.31h-5.05v-21.16h5.82c5.93,0,9.33,2.65,9.33,7.26v3.76c0,.42.03,1.02.06,1.53l-3.13,8.62h-4.1v.31h8.47v-.31h-4.05l2.85-7.83v.12s.08.71.08.71l.08.47c.48,2.89,1.58,5.01,3.28,6.31l.25.18c1.29.9,2.9,1.36,4.78,1.36,2.49,0,4.15-.62,5.52-2.08l-.18-.17c-1.26,1.16-2.32,1.64-3.64,1.64-2.27,0-3.45-2.74-3.45-5.45v-5.26c0-1.38-.21-2.67-.61-3.84l-.05-.16h0s10.37,0,10.37,0l5.04,14.03h-5v.31h17.08v-.31h-5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarlk2);
export default __webpack_public_path__ + "static/media/Varlık2.8fec6bb3edacb5adb28e74433b173c1a.svg";
export { ForwardRef as ReactComponent };